import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.scss';

const baseClass = 'NotFoundPage';

const NotFoundPage = () => {
  return (
    <div className={baseClass} style={{}}>
      <h1>404</h1>
      <p>Page not found</p>
      <Link to={'/'}>Go back to home</Link>
    </div>
  );
};

export default NotFoundPage;
